// =========================================================
// * Volt React Dashboard
// =========================================================

// * Product Page: https://themesberg.com/product/dashboard/volt-react
// * Copyright 2021 Themesberg (https://www.themesberg.com)
// * Official Repository: https://github.com/themesberg/volt-react-dashboard
// * License: MIT License (https://themesberg.com/licensing)

// * Designed and coded by https://themesberg.com

// =========================================================

// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software. Please contact us to request a removal.

import React from 'react';
import * as ReactDOM from 'react-dom/client';
import { HashRouter, Redirect } from "react-router-dom";
import { Routes } from "./routes";
import Amplify, { Cache } from 'aws-amplify';
import { Auth } from 'aws-amplify';
import Config from "./Config";

// core styles
import "./scss/volt.scss";

// vendor styles
import "@fortawesome/fontawesome-free/css/all.css";
import "react-datetime/css/react-datetime.css";

import App from "./App";
import ScrollToTop from "./components/ScrollToTop";

var currentHost = window.location.hostname || 'localhost';
var config = Config.getConfig(currentHost);

Amplify.configure({
    Auth: {
        mandatorySignIn: true,
        region: config.cognito.REGION,
        userPoolId: config.cognito.USER_POOL_ID,
        identityPoolId: config.cognito.IDENTITY_POOL_ID,
        userPoolWebClientId: config.cognito.APP_CLIENT_ID,
        oauth: {
            domain: config.cognito.DOMAIN,
            scope: ['email', 'profile', 'openid'],
            redirectSignIn: config.loginUrl,
            redirectSignOut: config.loginUrl,
            responseType: 'code'
          }
    },
          API: {
          endpoints: [
              {
                  name: config.apiGateway.NAME,
                  endpoint: config.apiGateway.URL,
                  region: config.apiGateway.REGION,
                  custom_header: async () => {
                    // return { Authorization : 'token' }
                    // Alternatively, with Cognito User Pools use this:
                    return { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` }
                    // return { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` }
                  }
              },
          ]
      },
    Storage: {
        identityPoolId: config.cognito.IDENTITY_POOL_ID
    }
  });
Cache.configure({itemMaxSize:1000000});

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

root.render(
  <HashRouter>
  <ScrollToTop />
  <Redirect to={Routes.InventorDashboard.path} />
  <App />
</HashRouter>
);